import { Box, HStack, IconButton, Button, Text } from '@chakra-ui/react'
import { FiChevronLeft, FiSave } from 'react-icons/fi'

interface TurfCutImmersiveBarProps {
  title: string
  onBack: () => void
  onSave: () => void
  saveDisabled: boolean
  saving: boolean
}

/**
 * A6 slice 3b: the phone immersive turf-cut top bar. Back (left) reuses the
 * page's unsaved-changes guard; Save Turf Map (right) is the persistent primary
 * action that MQ-5 asked to surface out of the buried legend sheet.
 */
export function TurfCutImmersiveBar({ title, onBack, onSave, saveDisabled, saving }: TurfCutImmersiveBarProps) {
  return (
    <Box
      bg="surface"
      borderBottom="1px"
      borderColor="border"
      pt="env(safe-area-inset-top, 0px)"
      flexShrink={0}
    >
      <HStack justify="space-between" gap={2} px={2} py={2}>
        <IconButton
          aria-label="Back"
          variant="ghost"
          colorPalette="gray"
          onClick={onBack}
          _touch={{ minH: '2.75rem', minW: '2.75rem' }}
        >
          <FiChevronLeft />
        </IconButton>
        <Text fontWeight="semibold" truncate flex={1} textAlign="center">{title}</Text>
        <Button
          colorPalette="brand"
          onClick={onSave}
          disabled={saveDisabled}
          loading={saving}
          minH="2.75rem"
        >
          <FiSave />Save Turf Map
        </Button>
      </HStack>
    </Box>
  )
}
